import { render, staticRenderFns } from "./SelectAllupch.vue?vue&type=template&id=3056f4d0&"
import script from "./SelectAllupch.vue?vue&type=script&lang=js&"
export * from "./SelectAllupch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports